import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit, signal } from '@angular/core';
import { DeviceManagerService } from '@app/core/services/device-manager.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AuthCarouselComponent } from '@app/shared/layout/auth-carousel/auth-carousel.component';

import { RouterOutlet } from '@angular/router';
import { AuthFooterComponent } from '@app/shared/layout/auth-footer/auth-footer.component';

@Component({
    selector: 'app-auth-layout',
    templateUrl: './auth-layout.component.html',
    styleUrls: ['./auth-layout.component.scss'],
    // OnPush (AB#24384). Under zone.js an OnPush ancestor left PrimeNG's p-carousel on the wrong slide with no dots
    // (PR-14449). Zoneless, auth-carousel hands the carousel its slides again after the first render (AB#23266 slice
    // 11), and that signal write refreshes the carousel whatever this layout's strategy is. showCarousel is a signal.
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [AuthCarouselComponent, RouterOutlet, AuthFooterComponent]
})
export class AuthLayoutComponent implements OnInit {
    private readonly destroyRef = inject(DestroyRef);

    private deviceManager = inject(DeviceManagerService);

    protected readonly showCarousel = signal(true);

    ngOnInit() {
        this.deviceManager.isAdoptiveDesignView
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(isAdoptive => {
                this.showCarousel.set(!isAdoptive);
            });
    }

}
